const map = {
	"./ajax-loader.gif": "./src/assets/images/ajax-loader.gif",
	"./appointment/app-ent.jpg": "./src/assets/images/appointment/app-ent.jpg",
	"./auth-img.svg": "./src/assets/images/auth-img.svg",
	"./auth0.svg": "./src/assets/images/auth0.svg",
	"./avtar/11.jpg": "./src/assets/images/avtar/11.jpg",
	"./avtar/16.jpg": "./src/assets/images/avtar/16.jpg",
	"./avtar/3.jpg": "./src/assets/images/avtar/3.jpg",
	"./avtar/4.jpg": "./src/assets/images/avtar/4.jpg",
	"./avtar/7.jpg": "./src/assets/images/avtar/7.jpg",
	"./banner/1.jpg": "./src/assets/images/banner/1.jpg",
	"./banner/2.jpg": "./src/assets/images/banner/2.jpg",
	"./banner/3.jpg": "./src/assets/images/banner/3.jpg",
	"./big-lightgallry/01.jpg": "./src/assets/images/big-lightgallry/01.jpg",
	"./big-lightgallry/010.jpg": "./src/assets/images/big-lightgallry/010.jpg",
	"./big-lightgallry/011.jpg": "./src/assets/images/big-lightgallry/011.jpg",
	"./big-lightgallry/012.jpg": "./src/assets/images/big-lightgallry/012.jpg",
	"./big-lightgallry/013.jpg": "./src/assets/images/big-lightgallry/013.jpg",
	"./big-lightgallry/014.jpg": "./src/assets/images/big-lightgallry/014.jpg",
	"./big-lightgallry/015.jpg": "./src/assets/images/big-lightgallry/015.jpg",
	"./big-lightgallry/016.jpg": "./src/assets/images/big-lightgallry/016.jpg",
	"./big-lightgallry/02.jpg": "./src/assets/images/big-lightgallry/02.jpg",
	"./big-lightgallry/03.jpg": "./src/assets/images/big-lightgallry/03.jpg",
	"./big-lightgallry/04.jpg": "./src/assets/images/big-lightgallry/04.jpg",
	"./big-lightgallry/05.jpg": "./src/assets/images/big-lightgallry/05.jpg",
	"./big-lightgallry/06.jpg": "./src/assets/images/big-lightgallry/06.jpg",
	"./big-lightgallry/07.jpg": "./src/assets/images/big-lightgallry/07.jpg",
	"./big-lightgallry/08.jpg": "./src/assets/images/big-lightgallry/08.jpg",
	"./big-lightgallry/09.jpg": "./src/assets/images/big-lightgallry/09.jpg",
	"./big-masonry/1.jpg": "./src/assets/images/big-masonry/1.jpg",
	"./big-masonry/10.jpg": "./src/assets/images/big-masonry/10.jpg",
	"./big-masonry/11.jpg": "./src/assets/images/big-masonry/11.jpg",
	"./big-masonry/12.jpg": "./src/assets/images/big-masonry/12.jpg",
	"./big-masonry/13.jpg": "./src/assets/images/big-masonry/13.jpg",
	"./big-masonry/14.jpg": "./src/assets/images/big-masonry/14.jpg",
	"./big-masonry/15.jpg": "./src/assets/images/big-masonry/15.jpg",
	"./big-masonry/2.jpg": "./src/assets/images/big-masonry/2.jpg",
	"./big-masonry/3.jpg": "./src/assets/images/big-masonry/3.jpg",
	"./big-masonry/4.jpg": "./src/assets/images/big-masonry/4.jpg",
	"./big-masonry/5.jpg": "./src/assets/images/big-masonry/5.jpg",
	"./big-masonry/6.jpg": "./src/assets/images/big-masonry/6.jpg",
	"./big-masonry/7.jpg": "./src/assets/images/big-masonry/7.jpg",
	"./big-masonry/8.jpg": "./src/assets/images/big-masonry/8.jpg",
	"./big-masonry/9.jpg": "./src/assets/images/big-masonry/9.jpg",
	"./blog/12.png": "./src/assets/images/blog/12.png",
	"./blog/14.png": "./src/assets/images/blog/14.png",
	"./blog/4.jpg": "./src/assets/images/blog/4.jpg",
	"./blog/9.jpg": "./src/assets/images/blog/9.jpg",
	"./blog/blog-2.jpg": "./src/assets/images/blog/blog-2.jpg",
	"./blog/blog-3.jpg": "./src/assets/images/blog/blog-3.jpg",
	"./blog/blog-5.jpg": "./src/assets/images/blog/blog-5.jpg",
	"./blog/blog-6.jpg": "./src/assets/images/blog/blog-6.jpg",
	"./blog/blog-single.jpg": "./src/assets/images/blog/blog-single.jpg",
	"./blog/blog.jpg": "./src/assets/images/blog/blog.jpg",
	"./blog/comment.jpg": "./src/assets/images/blog/comment.jpg",
	"./blog/img.png": "./src/assets/images/blog/img.png",
	"./button_builder/checkbox-sprite.png": "./src/assets/images/button_builder/checkbox-sprite.png",
	"./button_builder/colorpicker_overlay.png": "./src/assets/images/button_builder/colorpicker_overlay.png",
	"./button_builder/colorpicker_select.gif": "./src/assets/images/button_builder/colorpicker_select.gif",
	"./button_builder/hex_bg.gif": "./src/assets/images/button_builder/hex_bg.gif",
	"./button_builder/rainbow.png": "./src/assets/images/button_builder/rainbow.png",
	"./button_builder/scroll.png": "./src/assets/images/button_builder/scroll.png",
	"./button_builder/select.png": "./src/assets/images/button_builder/select.png",
	"./calender/ic-arrow-line-left.png": "./src/assets/images/calender/ic-arrow-line-left.png",
	"./calender/ic-arrow-line-left@3x.png": "./src/assets/images/calender/ic-arrow-line-left@3x.png",
	"./calender/ic-arrow-line-right.png": "./src/assets/images/calender/ic-arrow-line-right.png",
	"./calender/ic-arrow-line-right@2x.png": "./src/assets/images/calender/ic-arrow-line-right@2x.png",
	"./calender/ic-arrow-line-right@3x.png": "./src/assets/images/calender/ic-arrow-line-right@3x.png",
	"./calender/ic-traveltime-w.png": "./src/assets/images/calender/ic-traveltime-w.png",
	"./calender/ic-view-day.png": "./src/assets/images/calender/ic-view-day.png",
	"./calender/ic-view-day@2x.png": "./src/assets/images/calender/ic-view-day@2x.png",
	"./calender/ic-view-day@3x.png": "./src/assets/images/calender/ic-view-day@3x.png",
	"./calender/ic-view-month.png": "./src/assets/images/calender/ic-view-month.png",
	"./calender/ic-view-month@2x.png": "./src/assets/images/calender/ic-view-month@2x.png",
	"./calender/ic-view-month@3x.png": "./src/assets/images/calender/ic-view-month@3x.png",
	"./calender/ic-view-week.png": "./src/assets/images/calender/ic-view-week.png",
	"./calender/ic-view-week@2x.png": "./src/assets/images/calender/ic-view-week@2x.png",
	"./calender/ic-view-week@3x.png": "./src/assets/images/calender/ic-view-week@3x.png",
	"./calender/icon.png": "./src/assets/images/calender/icon.png",
	"./calender/img-bi.png": "./src/assets/images/calender/img-bi.png",
	"./calender/img-bi@2x.png": "./src/assets/images/calender/img-bi@2x.png",
	"./calender/img-bi@3x.png": "./src/assets/images/calender/img-bi@3x.png",
	"./checkout/paypal.png": "./src/assets/images/checkout/paypal.png",
	"./cuba-logo1.png": "./src/assets/images/cuba-logo1.png",
	"./dashboard-2/balance-bg.png": "./src/assets/images/dashboard-2/balance-bg.png",
	"./dashboard-2/category/1.png": "./src/assets/images/dashboard-2/category/1.png",
	"./dashboard-2/category/2.png": "./src/assets/images/dashboard-2/category/2.png",
	"./dashboard-2/category/3.png": "./src/assets/images/dashboard-2/category/3.png",
	"./dashboard-2/category/4.png": "./src/assets/images/dashboard-2/category/4.png",
	"./dashboard-2/category/5.png": "./src/assets/images/dashboard-2/category/5.png",
	"./dashboard-2/category/6.png": "./src/assets/images/dashboard-2/category/6.png",
	"./dashboard-2/category/7.png": "./src/assets/images/dashboard-2/category/7.png",
	"./dashboard-2/confetti-left.gif": "./src/assets/images/dashboard-2/confetti-left.gif",
	"./dashboard-2/discover.png": "./src/assets/images/dashboard-2/discover.png",
	"./dashboard-2/mobile.gif": "./src/assets/images/dashboard-2/mobile.gif",
	"./dashboard-2/order/1.png": "./src/assets/images/dashboard-2/order/1.png",
	"./dashboard-2/order/2.png": "./src/assets/images/dashboard-2/order/2.png",
	"./dashboard-2/order/3.png": "./src/assets/images/dashboard-2/order/3.png",
	"./dashboard-2/order/4.png": "./src/assets/images/dashboard-2/order/4.png",
	"./dashboard-2/order/5.png": "./src/assets/images/dashboard-2/order/5.png",
	"./dashboard-2/order/sub-product/1.png": "./src/assets/images/dashboard-2/order/sub-product/1.png",
	"./dashboard-2/order/sub-product/10.png": "./src/assets/images/dashboard-2/order/sub-product/10.png",
	"./dashboard-2/order/sub-product/2.png": "./src/assets/images/dashboard-2/order/sub-product/2.png",
	"./dashboard-2/order/sub-product/3.png": "./src/assets/images/dashboard-2/order/sub-product/3.png",
	"./dashboard-2/order/sub-product/4.png": "./src/assets/images/dashboard-2/order/sub-product/4.png",
	"./dashboard-2/order/sub-product/5.png": "./src/assets/images/dashboard-2/order/sub-product/5.png",
	"./dashboard-2/order/sub-product/6.png": "./src/assets/images/dashboard-2/order/sub-product/6.png",
	"./dashboard-2/order/sub-product/7.png": "./src/assets/images/dashboard-2/order/sub-product/7.png",
	"./dashboard-2/order/sub-product/8.png": "./src/assets/images/dashboard-2/order/sub-product/8.png",
	"./dashboard-2/order/sub-product/9.png": "./src/assets/images/dashboard-2/order/sub-product/9.png",
	"./dashboard-2/product/1.png": "./src/assets/images/dashboard-2/product/1.png",
	"./dashboard-2/product/2.png": "./src/assets/images/dashboard-2/product/2.png",
	"./dashboard-2/product/3.png": "./src/assets/images/dashboard-2/product/3.png",
	"./dashboard-2/widget-img.png": "./src/assets/images/dashboard-2/widget-img.png",
	"./dashboard-3/better.png": "./src/assets/images/dashboard-3/better.png",
	"./dashboard-3/bg.jpg": "./src/assets/images/dashboard-3/bg.jpg",
	"./dashboard-3/course/1.svg": "./src/assets/images/dashboard-3/course/1.svg",
	"./dashboard-3/course/2.svg": "./src/assets/images/dashboard-3/course/2.svg",
	"./dashboard-3/course/3.svg": "./src/assets/images/dashboard-3/course/3.svg",
	"./dashboard-3/course/4.svg": "./src/assets/images/dashboard-3/course/4.svg",
	"./dashboard-3/course/back-arrow/1.png": "./src/assets/images/dashboard-3/course/back-arrow/1.png",
	"./dashboard-3/course/back-arrow/2.png": "./src/assets/images/dashboard-3/course/back-arrow/2.png",
	"./dashboard-3/course/back-arrow/3.png": "./src/assets/images/dashboard-3/course/back-arrow/3.png",
	"./dashboard-3/hand.svg": "./src/assets/images/dashboard-3/hand.svg?a7bf",
	"./dashboard-3/lessons/1.png": "./src/assets/images/dashboard-3/lessons/1.png",
	"./dashboard-3/lessons/2.png": "./src/assets/images/dashboard-3/lessons/2.png",
	"./dashboard-3/lessons/3.png": "./src/assets/images/dashboard-3/lessons/3.png",
	"./dashboard-3/round.png": "./src/assets/images/dashboard-3/round.png",
	"./dashboard-3/widget.svg": "./src/assets/images/dashboard-3/widget.svg?664c",
	"./dashboard-4/bg-balance.png": "./src/assets/images/dashboard-4/bg-balance.png",
	"./dashboard-4/crypto.png": "./src/assets/images/dashboard-4/crypto.png",
	"./dashboard-4/portfolio-bg.png": "./src/assets/images/dashboard-4/portfolio-bg.png",
	"./dashboard-4/user.png": "./src/assets/images/dashboard-4/user.png",
	"./dashboard-5/follower.png": "./src/assets/images/dashboard-5/follower.png",
	"./dashboard-5/mobile-img.png": "./src/assets/images/dashboard-5/mobile-img.png",
	"./dashboard-5/profile-bg.png": "./src/assets/images/dashboard-5/profile-bg.png",
	"./dashboard-5/profile.png": "./src/assets/images/dashboard-5/profile.png",
	"./dashboard-5/social/1.png": "./src/assets/images/dashboard-5/social/1.png",
	"./dashboard-5/social/2.png": "./src/assets/images/dashboard-5/social/2.png",
	"./dashboard-5/social/3.png": "./src/assets/images/dashboard-5/social/3.png",
	"./dashboard-5/social/4.png": "./src/assets/images/dashboard-5/social/4.png",
	"./dashboard-5/wave.png": "./src/assets/images/dashboard-5/wave.png",
	"./dashboard/cartoon.svg": "./src/assets/images/dashboard/cartoon.svg?46e3",
	"./dashboard/folder.png": "./src/assets/images/dashboard/folder.png",
	"./dashboard/folder1.png": "./src/assets/images/dashboard/folder1.png",
	"./dashboard/papernote.jpg": "./src/assets/images/dashboard/papernote.jpg",
	"./dashboard/profile.png": "./src/assets/images/dashboard/profile.png",
	"./dashboard/purchase.png": "./src/assets/images/dashboard/purchase.png",
	"./dashboard/user/1.jpg": "./src/assets/images/dashboard/user/1.jpg",
	"./dashboard/user/10.jpg": "./src/assets/images/dashboard/user/10.jpg",
	"./dashboard/user/11.jpg": "./src/assets/images/dashboard/user/11.jpg",
	"./dashboard/user/12.jpg": "./src/assets/images/dashboard/user/12.jpg",
	"./dashboard/user/13.jpg": "./src/assets/images/dashboard/user/13.jpg",
	"./dashboard/user/2.jpg": "./src/assets/images/dashboard/user/2.jpg",
	"./dashboard/user/3.jpg": "./src/assets/images/dashboard/user/3.jpg",
	"./dashboard/user/4.jpg": "./src/assets/images/dashboard/user/4.jpg",
	"./dashboard/user/5.jpg": "./src/assets/images/dashboard/user/5.jpg",
	"./dashboard/user/6.jpg": "./src/assets/images/dashboard/user/6.jpg",
	"./dashboard/user/7.jpg": "./src/assets/images/dashboard/user/7.jpg",
	"./dashboard/user/8.jpg": "./src/assets/images/dashboard/user/8.jpg",
	"./dashboard/user/9.jpg": "./src/assets/images/dashboard/user/9.jpg",
	"./dashboard/widget-bg.png": "./src/assets/images/dashboard/widget-bg.png",
	"./details_open.png": "./src/assets/images/details_open.png",
	"./ecommerce/01.jpg": "./src/assets/images/ecommerce/01.jpg",
	"./ecommerce/02.jpg": "./src/assets/images/ecommerce/02.jpg",
	"./ecommerce/03.jpg": "./src/assets/images/ecommerce/03.jpg",
	"./ecommerce/04.jpg": "./src/assets/images/ecommerce/04.jpg",
	"./ecommerce/05.jpg": "./src/assets/images/ecommerce/05.jpg",
	"./ecommerce/06.jpg": "./src/assets/images/ecommerce/06.jpg",
	"./ecommerce/07.jpg": "./src/assets/images/ecommerce/07.jpg",
	"./ecommerce/08.jpg": "./src/assets/images/ecommerce/08.jpg",
	"./ecommerce/banner.jpg": "./src/assets/images/ecommerce/banner.jpg",
	"./ecommerce/card.png": "./src/assets/images/ecommerce/card.png",
	"./ecommerce/mastercard.png": "./src/assets/images/ecommerce/mastercard.png",
	"./ecommerce/paypal.png": "./src/assets/images/ecommerce/paypal.png",
	"./ecommerce/product-table-1.png": "./src/assets/images/ecommerce/product-table-1.png",
	"./ecommerce/product-table-2.png": "./src/assets/images/ecommerce/product-table-2.png",
	"./ecommerce/product-table-3.png": "./src/assets/images/ecommerce/product-table-3.png",
	"./ecommerce/product-table-4.png": "./src/assets/images/ecommerce/product-table-4.png",
	"./ecommerce/product-table-5.png": "./src/assets/images/ecommerce/product-table-5.png",
	"./ecommerce/product-table-6.png": "./src/assets/images/ecommerce/product-table-6.png",
	"./ecommerce/product-table-7.png": "./src/assets/images/ecommerce/product-table-7.png",
	"./ecommerce/product-table-8.png": "./src/assets/images/ecommerce/product-table-8.png",
	"./ecommerce/visa.png": "./src/assets/images/ecommerce/visa.png",
	"./email-template/1.jpg": "./src/assets/images/email-template/1.jpg",
	"./email-template/1.png": "./src/assets/images/email-template/1.png",
	"./email-template/10.jpg": "./src/assets/images/email-template/10.jpg",
	"./email-template/11.jpg": "./src/assets/images/email-template/11.jpg",
	"./email-template/12.jpg": "./src/assets/images/email-template/12.jpg",
	"./email-template/2.png": "./src/assets/images/email-template/2.png",
	"./email-template/3.png": "./src/assets/images/email-template/3.png",
	"./email-template/4.png": "./src/assets/images/email-template/4.png",
	"./email-template/5.png": "./src/assets/images/email-template/5.png",
	"./email-template/6.png": "./src/assets/images/email-template/6.png",
	"./email-template/7.jpg": "./src/assets/images/email-template/7.jpg",
	"./email-template/7.png": "./src/assets/images/email-template/7.png",
	"./email-template/8.jpg": "./src/assets/images/email-template/8.jpg",
	"./email-template/8.png": "./src/assets/images/email-template/8.png",
	"./email-template/banner-2.jpg": "./src/assets/images/email-template/banner-2.jpg",
	"./email-template/banner.jpg": "./src/assets/images/email-template/banner.jpg",
	"./email-template/cosmetic.jpg": "./src/assets/images/email-template/cosmetic.jpg",
	"./email-template/delivery-2.png": "./src/assets/images/email-template/delivery-2.png",
	"./email-template/delivery.png": "./src/assets/images/email-template/delivery.png",
	"./email-template/facebook.png": "./src/assets/images/email-template/facebook.png",
	"./email-template/gplus.png": "./src/assets/images/email-template/gplus.png",
	"./email-template/linkedin.png": "./src/assets/images/email-template/linkedin.png",
	"./email-template/order-success.png": "./src/assets/images/email-template/order-success.png",
	"./email-template/pinterest.png": "./src/assets/images/email-template/pinterest.png",
	"./email-template/slider.jpg": "./src/assets/images/email-template/slider.jpg",
	"./email-template/space.jpg": "./src/assets/images/email-template/space.jpg",
	"./email-template/success.png": "./src/assets/images/email-template/success.png",
	"./email-template/twitter.png": "./src/assets/images/email-template/twitter.png",
	"./email-template/youtube.png": "./src/assets/images/email-template/youtube.png",
	"./email/1.jpg": "./src/assets/images/email/1.jpg",
	"./email/2.jpg": "./src/assets/images/email/2.jpg",
	"./email/3.jpg": "./src/assets/images/email/3.jpg",
	"./faq/1.jpg": "./src/assets/images/faq/1.jpg",
	"./faq/2.jpg": "./src/assets/images/faq/2.jpg",
	"./faq/3.jpg": "./src/assets/images/faq/3.jpg",
	"./faq/4.jpg": "./src/assets/images/faq/4.jpg",
	"./faq/learning-1.png": "./src/assets/images/faq/learning-1.png",
	"./favicon.png": "./src/assets/images/favicon.png",
	"./favicon1.png": "./src/assets/images/favicon1.png",
	"./giftools.gif": "./src/assets/images/giftools.gif",
	"./hour.svg": "./src/assets/images/hour.svg",
	"./job-search/1.jpg": "./src/assets/images/job-search/1.jpg",
	"./job-search/2.jpg": "./src/assets/images/job-search/2.jpg",
	"./job-search/3.jpg": "./src/assets/images/job-search/3.jpg",
	"./job-search/4.jpg": "./src/assets/images/job-search/4.jpg",
	"./job-search/5.jpg": "./src/assets/images/job-search/5.jpg",
	"./job-search/6.jpg": "./src/assets/images/job-search/6.jpg",
	"./js-grid.png": "./src/assets/images/js-grid.png",
	"./jwt.svg": "./src/assets/images/jwt.svg",
	"./knowledgebase/bg_1.jpg": "./src/assets/images/knowledgebase/bg_1.jpg",
	"./landing/2.png": "./src/assets/images/landing/2.png",
	"./landing/apps/chat.jpg": "./src/assets/images/landing/apps/chat.jpg",
	"./landing/apps/file.jpg": "./src/assets/images/landing/apps/file.jpg",
	"./landing/apps/kanban.jpg": "./src/assets/images/landing/apps/kanban.jpg",
	"./landing/cards.png": "./src/assets/images/landing/cards.png",
	"./landing/customers/1.svg": "./src/assets/images/landing/customers/1.svg",
	"./landing/customers/2.svg": "./src/assets/images/landing/customers/2.svg",
	"./landing/customers/3.svg": "./src/assets/images/landing/customers/3.svg",
	"./landing/customers/4.svg": "./src/assets/images/landing/customers/4.svg",
	"./landing/customiztion.svg": "./src/assets/images/landing/customiztion.svg",
	"./landing/decore/arrow-3.svg": "./src/assets/images/landing/decore/arrow-3.svg",
	"./landing/decore/arrow-4.svg": "./src/assets/images/landing/decore/arrow-4.svg",
	"./landing/decore/arrow-style-1.svg": "./src/assets/images/landing/decore/arrow-style-1.svg",
	"./landing/decore/arrow-style-2.svg": "./src/assets/images/landing/decore/arrow-style-2.svg",
	"./landing/decore/arrow-style-3.svg": "./src/assets/images/landing/decore/arrow-style-3.svg",
	"./landing/decore/arrow-style-4.svg": "./src/assets/images/landing/decore/arrow-style-4.svg",
	"./landing/decore/arrow.svg": "./src/assets/images/landing/decore/arrow.svg",
	"./landing/ecommerce-app.jpg": "./src/assets/images/landing/ecommerce-app.jpg",
	"./landing/email_section_img.png": "./src/assets/images/landing/email_section_img.png",
	"./landing/feature-icon/1.svg": "./src/assets/images/landing/feature-icon/1.svg",
	"./landing/feature-icon/2.svg": "./src/assets/images/landing/feature-icon/2.svg",
	"./landing/feature-icon/3.svg": "./src/assets/images/landing/feature-icon/3.svg",
	"./landing/feature-icon/4.svg": "./src/assets/images/landing/feature-icon/4.svg",
	"./landing/feature-icon/5.svg": "./src/assets/images/landing/feature-icon/5.svg",
	"./landing/feature-icon/6.svg": "./src/assets/images/landing/feature-icon/6.svg",
	"./landing/feature-icon/7.svg": "./src/assets/images/landing/feature-icon/7.svg",
	"./landing/feature-icon/8.svg": "./src/assets/images/landing/feature-icon/8.svg",
	"./landing/feature-img.png": "./src/assets/images/landing/feature-img.png",
	"./landing/footer.jpg": "./src/assets/images/landing/footer.jpg",
	"./landing/gifs/3.gif": "./src/assets/images/landing/gifs/3.gif",
	"./landing/gifs/4.gif": "./src/assets/images/landing/gifs/4.gif",
	"./landing/gifs/5.gif": "./src/assets/images/landing/gifs/5.gif",
	"./landing/gifs/6.gif": "./src/assets/images/landing/gifs/6.gif",
	"./landing/home-bg.jpg": "./src/assets/images/landing/home-bg.jpg",
	"./landing/icon/1.svg": "./src/assets/images/landing/icon/1.svg",
	"./landing/icon/10.svg": "./src/assets/images/landing/icon/10.svg",
	"./landing/icon/11.svg": "./src/assets/images/landing/icon/11.svg",
	"./landing/icon/12.svg": "./src/assets/images/landing/icon/12.svg",
	"./landing/icon/13.svg": "./src/assets/images/landing/icon/13.svg",
	"./landing/icon/14.svg": "./src/assets/images/landing/icon/14.svg",
	"./landing/icon/15.svg": "./src/assets/images/landing/icon/15.svg",
	"./landing/icon/16.svg": "./src/assets/images/landing/icon/16.svg",
	"./landing/icon/17.svg": "./src/assets/images/landing/icon/17.svg",
	"./landing/icon/18.svg": "./src/assets/images/landing/icon/18.svg",
	"./landing/icon/19.svg": "./src/assets/images/landing/icon/19.svg",
	"./landing/icon/2.svg": "./src/assets/images/landing/icon/2.svg",
	"./landing/icon/20.svg": "./src/assets/images/landing/icon/20.svg",
	"./landing/icon/21.svg": "./src/assets/images/landing/icon/21.svg",
	"./landing/icon/22.svg": "./src/assets/images/landing/icon/22.svg",
	"./landing/icon/23.svg": "./src/assets/images/landing/icon/23.svg",
	"./landing/icon/24.svg": "./src/assets/images/landing/icon/24.svg",
	"./landing/icon/25.svg": "./src/assets/images/landing/icon/25.svg",
	"./landing/icon/26.svg": "./src/assets/images/landing/icon/26.svg",
	"./landing/icon/27.svg": "./src/assets/images/landing/icon/27.svg",
	"./landing/icon/28.svg": "./src/assets/images/landing/icon/28.svg",
	"./landing/icon/29.svg": "./src/assets/images/landing/icon/29.svg",
	"./landing/icon/3.svg": "./src/assets/images/landing/icon/3.svg",
	"./landing/icon/30.svg": "./src/assets/images/landing/icon/30.svg",
	"./landing/icon/4.svg": "./src/assets/images/landing/icon/4.svg",
	"./landing/icon/5.svg": "./src/assets/images/landing/icon/5.svg",
	"./landing/icon/6.svg": "./src/assets/images/landing/icon/6.svg",
	"./landing/icon/7.svg": "./src/assets/images/landing/icon/7.svg",
	"./landing/icon/8.svg": "./src/assets/images/landing/icon/8.svg",
	"./landing/icon/9.svg": "./src/assets/images/landing/icon/9.svg",
	"./landing/icon/angular/1.png": "./src/assets/images/landing/icon/angular/1.png",
	"./landing/icon/angular/10.png": "./src/assets/images/landing/icon/angular/10.png",
	"./landing/icon/angular/11.png": "./src/assets/images/landing/icon/angular/11.png",
	"./landing/icon/angular/12.png": "./src/assets/images/landing/icon/angular/12.png",
	"./landing/icon/angular/13.png": "./src/assets/images/landing/icon/angular/13.png",
	"./landing/icon/angular/14.png": "./src/assets/images/landing/icon/angular/14.png",
	"./landing/icon/angular/2.png": "./src/assets/images/landing/icon/angular/2.png",
	"./landing/icon/angular/4.png": "./src/assets/images/landing/icon/angular/4.png",
	"./landing/icon/angular/5.png": "./src/assets/images/landing/icon/angular/5.png",
	"./landing/icon/angular/6.png": "./src/assets/images/landing/icon/angular/6.png",
	"./landing/icon/angular/7.png": "./src/assets/images/landing/icon/angular/7.png",
	"./landing/icon/angular/8.png": "./src/assets/images/landing/icon/angular/8.png",
	"./landing/icon/angular/9.png": "./src/assets/images/landing/icon/angular/9.png",
	"./landing/icon/angular/angular.png": "./src/assets/images/landing/icon/angular/angular.png",
	"./landing/icon/angular/angular.svg": "./src/assets/images/landing/icon/angular/angular.svg",
	"./landing/icon/codeigniter/codeigniter-icon.png": "./src/assets/images/landing/icon/codeigniter/codeigniter-icon.png",
	"./landing/icon/django/apps.png": "./src/assets/images/landing/icon/django/apps.png",
	"./landing/icon/django/bootstrap.png": "./src/assets/images/landing/icon/django/bootstrap.png",
	"./landing/icon/django/builders.png": "./src/assets/images/landing/icon/django/builders.png",
	"./landing/icon/django/css.png": "./src/assets/images/landing/icon/django/css.png",
	"./landing/icon/django/django.png": "./src/assets/images/landing/icon/django/django.png",
	"./landing/icon/django/forms.png": "./src/assets/images/landing/icon/django/forms.png",
	"./landing/icon/django/iconset.png": "./src/assets/images/landing/icon/django/iconset.png",
	"./landing/icon/django/kit.png": "./src/assets/images/landing/icon/django/kit.png",
	"./landing/icon/django/layout.png": "./src/assets/images/landing/icon/django/layout.png",
	"./landing/icon/django/sass.png": "./src/assets/images/landing/icon/django/sass.png",
	"./landing/icon/django/table.png": "./src/assets/images/landing/icon/django/table.png",
	"./landing/icon/django/uikits.png": "./src/assets/images/landing/icon/django/uikits.png",
	"./landing/icon/flask/flask.png": "./src/assets/images/landing/icon/flask/flask.png",
	"./landing/icon/html/apps.png": "./src/assets/images/landing/icon/html/apps.png",
	"./landing/icon/html/bootstrap.png": "./src/assets/images/landing/icon/html/bootstrap.png",
	"./landing/icon/html/builders.png": "./src/assets/images/landing/icon/html/builders.png",
	"./landing/icon/html/css.png": "./src/assets/images/landing/icon/html/css.png",
	"./landing/icon/html/forms.png": "./src/assets/images/landing/icon/html/forms.png",
	"./landing/icon/html/gulp.png": "./src/assets/images/landing/icon/html/gulp.png",
	"./landing/icon/html/html.png": "./src/assets/images/landing/icon/html/html.png",
	"./landing/icon/html/iconset.png": "./src/assets/images/landing/icon/html/iconset.png",
	"./landing/icon/html/kit.png": "./src/assets/images/landing/icon/html/kit.png",
	"./landing/icon/html/layout.png": "./src/assets/images/landing/icon/html/layout.png",
	"./landing/icon/html/npm.png": "./src/assets/images/landing/icon/html/npm.png",
	"./landing/icon/html/pug.png": "./src/assets/images/landing/icon/html/pug.png",
	"./landing/icon/html/sass.png": "./src/assets/images/landing/icon/html/sass.png",
	"./landing/icon/html/table.png": "./src/assets/images/landing/icon/html/table.png",
	"./landing/icon/html/uikits.png": "./src/assets/images/landing/icon/html/uikits.png",
	"./landing/icon/laravel/blade.png": "./src/assets/images/landing/icon/laravel/blade.png",
	"./landing/icon/laravel/bootstrap.png": "./src/assets/images/landing/icon/laravel/bootstrap.png",
	"./landing/icon/laravel/laravel.png": "./src/assets/images/landing/icon/laravel/laravel.png",
	"./landing/icon/laravel/laravel2.png": "./src/assets/images/landing/icon/laravel/laravel2.png",
	"./landing/icon/laravel/layouts.png": "./src/assets/images/landing/icon/laravel/layouts.png",
	"./landing/icon/laravel/mix.png": "./src/assets/images/landing/icon/laravel/mix.png",
	"./landing/icon/laravel/sasswebpack.png": "./src/assets/images/landing/icon/laravel/sasswebpack.png",
	"./landing/icon/laravel/yarn.png": "./src/assets/images/landing/icon/laravel/yarn.png",
	"./landing/icon/minus.svg": "./src/assets/images/landing/icon/minus.svg",
	"./landing/icon/node/1.png": "./src/assets/images/landing/icon/node/1.png",
	"./landing/icon/node/2.png": "./src/assets/images/landing/icon/node/2.png",
	"./landing/icon/plus.svg": "./src/assets/images/landing/icon/plus.svg",
	"./landing/icon/react/animation.png": "./src/assets/images/landing/icon/react/animation.png",
	"./landing/icon/react/application.png": "./src/assets/images/landing/icon/react/application.png",
	"./landing/icon/react/chart.png": "./src/assets/images/landing/icon/react/chart.png",
	"./landing/icon/react/chat.png": "./src/assets/images/landing/icon/react/chat.png",
	"./landing/icon/react/crud.png": "./src/assets/images/landing/icon/react/crud.png",
	"./landing/icon/react/firebase.png": "./src/assets/images/landing/icon/react/firebase.png",
	"./landing/icon/react/gallery.png": "./src/assets/images/landing/icon/react/gallery.png",
	"./landing/icon/react/hook.png": "./src/assets/images/landing/icon/react/hook.png",
	"./landing/icon/react/map.png": "./src/assets/images/landing/icon/react/map.png",
	"./landing/icon/react/noquery.png": "./src/assets/images/landing/icon/react/noquery.png",
	"./landing/icon/react/props_state.png": "./src/assets/images/landing/icon/react/props_state.png",
	"./landing/icon/react/react.png": "./src/assets/images/landing/icon/react/react.png",
	"./landing/icon/react/react1.png": "./src/assets/images/landing/icon/react/react1.png",
	"./landing/icon/react/reactrouter.png": "./src/assets/images/landing/icon/react/reactrouter.png",
	"./landing/icon/react/reactstrap.png": "./src/assets/images/landing/icon/react/reactstrap.png",
	"./landing/icon/react/redux.png": "./src/assets/images/landing/icon/react/redux.png",
	"./landing/icon/right.svg": "./src/assets/images/landing/icon/right.svg",
	"./landing/icon/svelte/1.png": "./src/assets/images/landing/icon/svelte/1.png",
	"./landing/icon/svelte/2.png": "./src/assets/images/landing/icon/svelte/2.png",
	"./landing/icon/vue/animation.png": "./src/assets/images/landing/icon/vue/animation.png",
	"./landing/icon/vue/chart.png": "./src/assets/images/landing/icon/vue/chart.png",
	"./landing/icon/vue/firebase.png": "./src/assets/images/landing/icon/vue/firebase.png",
	"./landing/icon/vue/nojquery.png": "./src/assets/images/landing/icon/vue/nojquery.png",
	"./landing/icon/vue/rangeslider.png": "./src/assets/images/landing/icon/vue/rangeslider.png",
	"./landing/icon/vue/rtlsupport.png": "./src/assets/images/landing/icon/vue/rtlsupport.png",
	"./landing/icon/vue/vue.png": "./src/assets/images/landing/icon/vue/vue.png",
	"./landing/icon/vue/vuebootstrap.png": "./src/assets/images/landing/icon/vue/vuebootstrap.png",
	"./landing/icon/vue/vuecli.png": "./src/assets/images/landing/icon/vue/vuecli.png",
	"./landing/icon/vue/vuemasonary.png": "./src/assets/images/landing/icon/vue/vuemasonary.png",
	"./landing/icon/vue/vuerouter.png": "./src/assets/images/landing/icon/vue/vuerouter.png",
	"./landing/icon/vue/vueswiper.png": "./src/assets/images/landing/icon/vue/vueswiper.png",
	"./landing/icon/vue/vuex.png": "./src/assets/images/landing/icon/vue/vuex.png",
	"./landing/icon/wrong.png": "./src/assets/images/landing/icon/wrong.png",
	"./landing/job-search-app.jpg": "./src/assets/images/landing/job-search-app.jpg",
	"./landing/knowlagebase-app.jpg": "./src/assets/images/landing/knowlagebase-app.jpg",
	"./landing/landing_logo.png": "./src/assets/images/landing/landing_logo.png",
	"./landing/layout-images/barc.jpg": "./src/assets/images/landing/layout-images/barc.jpg",
	"./landing/layout-images/dubai.jpg": "./src/assets/images/landing/layout-images/dubai.jpg",
	"./landing/layout-images/london.jpg": "./src/assets/images/landing/layout-images/london.jpg",
	"./landing/layout-images/los.jpg": "./src/assets/images/landing/layout-images/los.jpg",
	"./landing/layout-images/madrid.jpg": "./src/assets/images/landing/layout-images/madrid.jpg",
	"./landing/layout-images/moscow.jpg": "./src/assets/images/landing/layout-images/moscow.jpg",
	"./landing/layout-images/newyork.jpg": "./src/assets/images/landing/layout-images/newyork.jpg",
	"./landing/layout-images/paris.jpg": "./src/assets/images/landing/layout-images/paris.jpg",
	"./landing/layout-images/romo.jpg": "./src/assets/images/landing/layout-images/romo.jpg",
	"./landing/layout-images/seoul.jpg": "./src/assets/images/landing/layout-images/seoul.jpg",
	"./landing/layout-images/singapore.jpg": "./src/assets/images/landing/layout-images/singapore.jpg",
	"./landing/layout-images/tokyo.jpg": "./src/assets/images/landing/layout-images/tokyo.jpg",
	"./landing/sale.png": "./src/assets/images/landing/sale.png",
	"./landing/screen1.png": "./src/assets/images/landing/screen1.png",
	"./landing/social-app.jpg": "./src/assets/images/landing/social-app.jpg",
	"./landing/stroke-icon/1.svg": "./src/assets/images/landing/stroke-icon/1.svg",
	"./landing/stroke-icon/10.svg": "./src/assets/images/landing/stroke-icon/10.svg",
	"./landing/stroke-icon/11.svg": "./src/assets/images/landing/stroke-icon/11.svg",
	"./landing/stroke-icon/2.svg": "./src/assets/images/landing/stroke-icon/2.svg",
	"./landing/stroke-icon/3.svg": "./src/assets/images/landing/stroke-icon/3.svg",
	"./landing/stroke-icon/4.svg": "./src/assets/images/landing/stroke-icon/4.svg",
	"./landing/stroke-icon/5.svg": "./src/assets/images/landing/stroke-icon/5.svg",
	"./landing/stroke-icon/6.svg": "./src/assets/images/landing/stroke-icon/6.svg",
	"./landing/stroke-icon/7.svg": "./src/assets/images/landing/stroke-icon/7.svg",
	"./landing/stroke-icon/8.svg": "./src/assets/images/landing/stroke-icon/8.svg",
	"./landing/stroke-icon/9.svg": "./src/assets/images/landing/stroke-icon/9.svg",
	"./landing/testimonial/1.svg": "./src/assets/images/landing/testimonial/1.svg",
	"./landing/testimonial/2.svg": "./src/assets/images/landing/testimonial/2.svg",
	"./landing/testimonial/3.svg": "./src/assets/images/landing/testimonial/3.svg",
	"./landing/vectors/1.svg": "./src/assets/images/landing/vectors/1.svg",
	"./landing/vectors/2.svg": "./src/assets/images/landing/vectors/2.svg",
	"./landing/vectors/3.svg": "./src/assets/images/landing/vectors/3.svg",
	"./landing/vectors/4.svg": "./src/assets/images/landing/vectors/4.svg",
	"./layouts/barc.jpg": "./src/assets/images/layouts/barc.jpg",
	"./layouts/dubai.jpg": "./src/assets/images/layouts/dubai.jpg",
	"./layouts/london.jpg": "./src/assets/images/layouts/london.jpg",
	"./layouts/los.jpg": "./src/assets/images/layouts/los.jpg",
	"./layouts/madrid.jpg": "./src/assets/images/layouts/madrid.jpg",
	"./layouts/moscow.jpg": "./src/assets/images/layouts/moscow.jpg",
	"./layouts/newyork.jpg": "./src/assets/images/layouts/newyork.jpg",
	"./layouts/paris.jpg": "./src/assets/images/layouts/paris.jpg",
	"./layouts/romo.jpg": "./src/assets/images/layouts/romo.jpg",
	"./layouts/seoul.jpg": "./src/assets/images/layouts/seoul.jpg",
	"./layouts/singapore.jpg": "./src/assets/images/layouts/singapore.jpg",
	"./layouts/tokyo.jpg": "./src/assets/images/layouts/tokyo.jpg",
	"./lightgallry/01.jpg": "./src/assets/images/lightgallry/01.jpg",
	"./lightgallry/010.jpg": "./src/assets/images/lightgallry/010.jpg",
	"./lightgallry/011.jpg": "./src/assets/images/lightgallry/011.jpg",
	"./lightgallry/012.jpg": "./src/assets/images/lightgallry/012.jpg",
	"./lightgallry/013.jpg": "./src/assets/images/lightgallry/013.jpg",
	"./lightgallry/014.jpg": "./src/assets/images/lightgallry/014.jpg",
	"./lightgallry/015.jpg": "./src/assets/images/lightgallry/015.jpg",
	"./lightgallry/016.jpg": "./src/assets/images/lightgallry/016.jpg",
	"./lightgallry/02.jpg": "./src/assets/images/lightgallry/02.jpg",
	"./lightgallry/03.jpg": "./src/assets/images/lightgallry/03.jpg",
	"./lightgallry/04.jpg": "./src/assets/images/lightgallry/04.jpg",
	"./lightgallry/05.jpg": "./src/assets/images/lightgallry/05.jpg",
	"./lightgallry/06.jpg": "./src/assets/images/lightgallry/06.jpg",
	"./lightgallry/07.jpg": "./src/assets/images/lightgallry/07.jpg",
	"./lightgallry/08.jpg": "./src/assets/images/lightgallry/08.jpg",
	"./lightgallry/09.jpg": "./src/assets/images/lightgallry/09.jpg",
	"./lightgallry/default-skin.png": "./src/assets/images/lightgallry/default-skin.png",
	"./lightgallry/default-skin.svg": "./src/assets/images/lightgallry/default-skin.svg",
	"./login/1.jpg": "./src/assets/images/login/1.jpg",
	"./login/2.jpg": "./src/assets/images/login/2.jpg",
	"./login/3.jpg": "./src/assets/images/login/3.jpg",
	"./login/auth-img.svg": "./src/assets/images/login/auth-img.svg",
	"./login/auth0.svg": "./src/assets/images/login/auth0.svg",
	"./login/firebase.svg": "./src/assets/images/login/firebase.svg",
	"./login/icon.png": "./src/assets/images/login/icon.png",
	"./login/jwt.svg": "./src/assets/images/login/jwt.svg",
	"./login/login_bg copy.jpg": "./src/assets/images/login/login_bg copy.jpg",
	"./login/login_bg.jpg": "./src/assets/images/login/login_bg.jpg",
	"./logo/logo-icon.png": "./src/assets/images/logo/logo-icon.png",
	"./logo/logo.png": "./src/assets/images/logo/logo.png",
	"./logo/logo1.png": "./src/assets/images/logo/logo1.png",
	"./logo/logo_dark.png": "./src/assets/images/logo/logo_dark.png",
	"./masonry/1.jpg": "./src/assets/images/masonry/1.jpg",
	"./masonry/10.jpg": "./src/assets/images/masonry/10.jpg",
	"./masonry/11.jpg": "./src/assets/images/masonry/11.jpg",
	"./masonry/12.jpg": "./src/assets/images/masonry/12.jpg",
	"./masonry/13.jpg": "./src/assets/images/masonry/13.jpg",
	"./masonry/14.jpg": "./src/assets/images/masonry/14.jpg",
	"./masonry/15.jpg": "./src/assets/images/masonry/15.jpg",
	"./masonry/2.jpg": "./src/assets/images/masonry/2.jpg",
	"./masonry/3.jpg": "./src/assets/images/masonry/3.jpg",
	"./masonry/4.jpg": "./src/assets/images/masonry/4.jpg",
	"./masonry/5.jpg": "./src/assets/images/masonry/5.jpg",
	"./masonry/6.jpg": "./src/assets/images/masonry/6.jpg",
	"./masonry/7.jpg": "./src/assets/images/masonry/7.jpg",
	"./masonry/8.jpg": "./src/assets/images/masonry/8.jpg",
	"./masonry/9.jpg": "./src/assets/images/masonry/9.jpg",
	"./min.svg": "./src/assets/images/min.svg",
	"./notification/1.jpg": "./src/assets/images/notification/1.jpg",
	"./notification/2.jpg": "./src/assets/images/notification/2.jpg",
	"./other-images/bg-profile.png": "./src/assets/images/other-images/bg-profile.png",
	"./other-images/boxbg.jpg": "./src/assets/images/other-images/boxbg.jpg",
	"./other-images/calender-bg.png": "./src/assets/images/other-images/calender-bg.png",
	"./other-images/calender-widget.jpg": "./src/assets/images/other-images/calender-widget.jpg",
	"./other-images/caller.jpg": "./src/assets/images/other-images/caller.jpg",
	"./other-images/cart-img.jpg": "./src/assets/images/other-images/cart-img.jpg",
	"./other-images/clock-face.png": "./src/assets/images/other-images/clock-face.png",
	"./other-images/coming-soon-bg.jpg": "./src/assets/images/other-images/coming-soon-bg.jpg",
	"./other-images/img-cropper.jpg": "./src/assets/images/other-images/img-cropper.jpg",
	"./other-images/logo-login.png": "./src/assets/images/other-images/logo-login.png",
	"./other-images/maintenance-bg.jpg": "./src/assets/images/other-images/maintenance-bg.jpg",
	"./other-images/mobile-clock-wallpaper.jpg": "./src/assets/images/other-images/mobile-clock-wallpaper.jpg",
	"./other-images/paypal.png": "./src/assets/images/other-images/paypal.png",
	"./other-images/profile-style-img.png": "./src/assets/images/other-images/profile-style-img.png",
	"./other-images/profile-style-img3.png": "./src/assets/images/other-images/profile-style-img3.png",
	"./other-images/receiver-img.jpg": "./src/assets/images/other-images/receiver-img.jpg",
	"./other-images/sad.png": "./src/assets/images/other-images/sad.png",
	"./other-images/sidebar-bg.jpg": "./src/assets/images/other-images/sidebar-bg.jpg",
	"./other-images/user-profile.png": "./src/assets/images/other-images/user-profile.png",
	"./other-images/wallpaper.jpg": "./src/assets/images/other-images/wallpaper.jpg",
	"./product/1.png": "./src/assets/images/product/1.png",
	"./product/10.png": "./src/assets/images/product/10.png",
	"./product/11.png": "./src/assets/images/product/11.png",
	"./product/12.png": "./src/assets/images/product/12.png",
	"./product/13.png": "./src/assets/images/product/13.png",
	"./product/14.png": "./src/assets/images/product/14.png",
	"./product/15.png": "./src/assets/images/product/15.png",
	"./product/2.png": "./src/assets/images/product/2.png",
	"./product/3.png": "./src/assets/images/product/3.png",
	"./product/4.png": "./src/assets/images/product/4.png",
	"./range-slider/sprite-skin-modern.png": "./src/assets/images/range-slider/sprite-skin-modern.png",
	"./search-not-found.png": "./src/assets/images/search-not-found.png",
	"./sec.svg": "./src/assets/images/sec.svg",
	"./simple-login.svg": "./src/assets/images/simple-login.svg",
	"./slider-auto-width/11.jpg": "./src/assets/images/slider-auto-width/11.jpg",
	"./slider-auto-width/12.jpg": "./src/assets/images/slider-auto-width/12.jpg",
	"./slider-auto-width/13.jpg": "./src/assets/images/slider-auto-width/13.jpg",
	"./slider-auto-width/14.jpg": "./src/assets/images/slider-auto-width/14.jpg",
	"./slider-auto-width/15.jpg": "./src/assets/images/slider-auto-width/15.jpg",
	"./slider/1.jpg": "./src/assets/images/slider/1.jpg",
	"./slider/10.jpg": "./src/assets/images/slider/10.jpg",
	"./slider/11.jpg": "./src/assets/images/slider/11.jpg",
	"./slider/2.jpg": "./src/assets/images/slider/2.jpg",
	"./slider/3.jpg": "./src/assets/images/slider/3.jpg",
	"./slider/4.jpg": "./src/assets/images/slider/4.jpg",
	"./slider/5.jpg": "./src/assets/images/slider/5.jpg",
	"./slider/6.jpg": "./src/assets/images/slider/6.jpg",
	"./slider/7.jpg": "./src/assets/images/slider/7.jpg",
	"./slider/8.jpg": "./src/assets/images/slider/8.jpg",
	"./slider/9.jpg": "./src/assets/images/slider/9.jpg",
	"./smiley.png": "./src/assets/images/smiley.png",
	"./social-app/post-1.png": "./src/assets/images/social-app/post-1.png",
	"./social-app/post-2.png": "./src/assets/images/social-app/post-2.png",
	"./social-app/post-3.png": "./src/assets/images/social-app/post-3.png",
	"./social-app/post-4.png": "./src/assets/images/social-app/post-4.png",
	"./social-app/post-5.png": "./src/assets/images/social-app/post-5.png",
	"./social-app/post-6.png": "./src/assets/images/social-app/post-6.png",
	"./social-app/post-7.png": "./src/assets/images/social-app/post-7.png",
	"./social-app/post-8.png": "./src/assets/images/social-app/post-8.png",
	"./social-app/post-9.png": "./src/assets/images/social-app/post-9.png",
	"./social-app/social-image.png": "./src/assets/images/social-app/social-image.png",
	"./social-app/timeline-1.png": "./src/assets/images/social-app/timeline-1.png",
	"./social-app/timeline-2.png": "./src/assets/images/social-app/timeline-2.png",
	"./social-app/timeline-3.png": "./src/assets/images/social-app/timeline-3.png",
	"./social-app/timeline-4.png": "./src/assets/images/social-app/timeline-4.png",
	"./sort_asc.png": "./src/assets/images/sort_asc.png",
	"./sort_asc_disabled.png": "./src/assets/images/sort_asc_disabled.png",
	"./sort_both.png": "./src/assets/images/sort_both.png",
	"./sort_desc.png": "./src/assets/images/sort_desc.png",
	"./sort_desc_disabled.png": "./src/assets/images/sort_desc_disabled.png",
	"./start-conversion.jpg": "./src/assets/images/start-conversion.jpg",
	"./svg-icon/1.svg": "./src/assets/images/svg-icon/1.svg",
	"./svg-icon/2.svg": "./src/assets/images/svg-icon/2.svg",
	"./svg-icon/3.svg": "./src/assets/images/svg-icon/3.svg",
	"./svg-icon/4.svg": "./src/assets/images/svg-icon/4.svg",
	"./svg-icon/5.svg": "./src/assets/images/svg-icon/5.svg",
	"./svg-icon/6.svg": "./src/assets/images/svg-icon/6.svg",
	"./tree/32px.png": "./src/assets/images/tree/32px.png",
	"./tree/40px.png": "./src/assets/images/tree/40px.png",
	"./tree/throbber.gif": "./src/assets/images/tree/throbber.gif",
	"./user-card/1.jpg": "./src/assets/images/user-card/1.jpg",
	"./user-card/2.jpg": "./src/assets/images/user-card/2.jpg",
	"./user-card/3.jpg": "./src/assets/images/user-card/3.jpg",
	"./user-card/4.jpg": "./src/assets/images/user-card/4.jpg",
	"./user-card/5.jpg": "./src/assets/images/user-card/5.jpg",
	"./user-card/6.jpg": "./src/assets/images/user-card/6.jpg",
	"./user-card/7.jpg": "./src/assets/images/user-card/7.jpg",
	"./user.jpg": "./src/assets/images/user.jpg",
	"./user/1.jpg": "./src/assets/images/user/1.jpg",
	"./user/10.jpg": "./src/assets/images/user/10.jpg",
	"./user/11.png": "./src/assets/images/user/11.png",
	"./user/12.png": "./src/assets/images/user/12.png",
	"./user/14.png": "./src/assets/images/user/14.png",
	"./user/16.png": "./src/assets/images/user/16.png",
	"./user/2.jpg": "./src/assets/images/user/2.jpg",
	"./user/2.png": "./src/assets/images/user/2.png",
	"./user/3.jpg": "./src/assets/images/user/3.jpg",
	"./user/3.png": "./src/assets/images/user/3.png",
	"./user/4.jpg": "./src/assets/images/user/4.jpg",
	"./user/5.jpg": "./src/assets/images/user/5.jpg",
	"./user/6.jpg": "./src/assets/images/user/6.jpg",
	"./user/7.jpg": "./src/assets/images/user/7.jpg",
	"./user/8.jpg": "./src/assets/images/user/8.jpg",
	"./user/9.jpg": "./src/assets/images/user/9.jpg",
	"./user/user-dp.png": "./src/assets/images/user/user-dp.png",
	"./user/user.png": "./src/assets/images/user/user.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";